import { render, staticRenderFns } from "./ButtonExportPdf.vue?vue&type=template&id=6222c3a1&"
import script from "./ButtonExportPdf.vue?vue&type=script&lang=js&"
export * from "./ButtonExportPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports